<template>
  <div class="zoom-container"
       v-show="isVisible"
  >
    <zoom-slider-wrapper />
    <zoom-button-list/>
  </div>
</template>

<script>
  import ZoomButtonList from './ZoomButtonList';
  import { viewportOverlayMixin } from '../viewport-overlay';
  import ZoomSliderWrapper from './ZoomSliderWrapper';

  export default {
    name: 'ZoomContainer',
    components: { ZoomSliderWrapper, ZoomButtonList },
    mixins: [viewportOverlayMixin],
    provide () {
      return {
        viewport: this.viewport,
        userPrefs: this.userPrefs
      };
    }
  };
</script>

<style scoped lang="scss">
.zoom-container {
  position: absolute;
  margin-left: 15px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}
</style>



// WEBPACK FOOTER //
// src/uScope/js/extensions/zoom/ZoomContainer.vue